import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { getDeviationResourceType } from '@wix/da-shared-react/pkg/DeviationViews/_helpers';
import { AppState } from '../../../../types/store';
import useModuleData from '../../../../utils/hooks/useModuleData';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import Tiers from './Tiers.connected';
import { setSelectedTierId } from '../../../actions/subscriptionsSection';
import { getSelectedTierId } from '../../../selectors/subscriptionsSection';

const TiersBox: React.FC<WidgetBoxProps> = ({
  moduleId,
  widgetMoveUp,
  widgetMoveDown,
  widgetRemove,
  isCurrentUserProfileOwner,
  profileOwnerUser,
  section,
  zone,
  ...props
}) => {
  const { t } = useTranslation();
  const logBiEvent = useBiLogger();
  const {
    moduleData: { tiers = [] },
  } = useModuleData(moduleId);
  const count = tiers.length;
  const dispatch = useDispatch();
  const isEmpty = count === 0;
  const selectedTierId = useSelector<AppState, any>(state =>
    getSelectedTierId(state)
  );
  const selectTier = useCallback(
    tier => {
      if (tier.deviationId !== selectedTierId) {
        logBiEvent({
          evid: BiEventType.TIER_NAVIGATION_SELECT,
          typeid: getDeviationResourceType(tier),
          itemid: tier.deviationId,
          authorid: tier?.author?.useridUuid,
        });
      }
      dispatch(setSelectedTierId(tier.deviationId));
    },
    [logBiEvent, dispatch, selectedTierId]
  );

  return (
    <WidgetBox
      section={section}
      zone={zone}
      header={t('widgets.tiers.header', { count })}
      count={count > 1 ? count : undefined}
      hasMore={false}
      moduleId={moduleId}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      isEmpty={isEmpty}
      biData={{
        referral_info: ReferralType.SUBSCRIPTIONS_WIDGET,
        widgetname: 'tiers_product',
      }}
    >
      <Tiers
        moduleId={moduleId}
        view={'product'}
        withExpandButton={true}
        {...props}
        isOwner={isCurrentUserProfileOwner}
        onClick={selectTier}
        onSelect={selectTier}
        selectedTierId={selectedTierId}
      />
    </WidgetBox>
  );
};

TiersBox.displayName = 'TiersBox';
export default TiersBox;
